module.exports = __webpack_public_path__ + "img/romy-scheffold.92fe8e5a.jpg";